import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { OpenSquashService } from '../../shared/services/open-squash-service';

@Component({
  selector: 'app-create-player-component',
  imports: [CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule],
  templateUrl: './create-player-component.html',
  styleUrl: './create-player-component.scss'
})
export class CreatePlayerComponent {
  private dialogRef = inject(MatDialogRef<CreatePlayerComponent>);
  private fb = inject(FormBuilder);

  private openSquashService = inject(OpenSquashService);

  form: FormGroup = this.fb.group({
    playerId: ['', Validators.required],
    playerLabel: ['', Validators.required],
    playerName: ['', Validators.required]
  });
  

  submit() {
    if (this.form.valid) {
      this.openSquashService.createPlayer(this.form.value).subscribe((player) => {
        this.openSquashService.reloadPlayers();
        this.dialogRef.close(this.form.value);
      });
    }
  }

  exit() {
    this.dialogRef.close(null);
  }
}
